import React, { forwardRef } from "react"
import { Col } from "reactstrap"
import WidgetRenderer from "./WidgetRenderer"

const WidgetItem = forwardRef(
  ({ withOpacity, isDragging, style, handleRemoveWidget, ...props }, ref) => {
    const inlineStyles = {
      padding: "5",
      display: "inline-flex",
      width: isDragging ? "100%" : "",
      height: isDragging ? "100%" : "",
      ...style,
    }

    const setClass = widget => {
      switch (widget) {
        case "session_report":
          return "col-xl-4"
        case "active_users":
          return "col-xl-4"
        case "device_report":
          return "col-xl-4"
        case "users_report":
          return "col-xl-12"
        case "exp_report":
          return "col-xl-12"
        case "ad_report":
          return "col-xl-12"
        case "booking_transactions":
          return "col-xl-12"
        case "products_subscriprions_transactions":
          return "col-xl-12"
        case "form_builder_transactions":
          return "col-xl-12"
        default:
          return <></>
      }
    }

    return (
      <div
        {...props}
        ref={ref}
        style={inlineStyles}
        className={`${setClass(props?.name)} `}
      >
        <WidgetRenderer
          name={props?.name}
          handleRemoveWidget={handleRemoveWidget}
        />
      </div>
    )
  }
)

export default WidgetItem
